/**
 * Utility function to translate inventory status values for display
 */
export const getTranslatedInventoryStatus = (
  facetId: string,
  status: string,
  tInventory: (key: 'inStock' | 'incoming' | 'order' | 'sold') => string,
): string => {
  if (facetId !== 'inventoryStatus') return status;

  // Map API values to translation keys
  const statusMap: Record<string, string> = {
    InStock: 'inStock',
    Incoming: 'incoming',
    Order: 'order',
    Sold: 'sold',
  };

  const translationKey = statusMap[status];
  if (translationKey) {
    try {
      return tInventory(translationKey as 'inStock' | 'incoming' | 'order' | 'sold');
    } catch {
      // Fallback to original value if translation fails
      return status;
    }
  }
  return status;
};
